// Load the preference widget
document.addEventListener("DOMContentLoaded", function (event) {
  function getRootDomain(url) {
    try {
      const domain = new URL(url).hostname;
      const elems = domain.split(".");
      const iMax = elems.length - 1;
      const isSecondLevel =
        elems.length >= 3 && (elems[iMax] + elems[iMax - 1]).length <= 5;
      return elems.splice(isSecondLevel ? -3 : -2).join(".");
    } catch (error) {
      return null;
    }
  }

  function loadScript(src, onSuccess, onError) {
    const script = document.createElement("script");
    script.src = src;
    script.onload = () => {
      if (onSuccess) onSuccess();
    };
    script.onerror = () => {
      if (onError) onError();
    };
    document.head.appendChild(script);
  }

  function initCassieWidget() {
    var WidgetId = 1;
    var LicenseKey = "D0A47C10-5DA3-412D-9232-B6073B69BD3D";
    var AccessKey = "D0A47C10-5DA3-412D-9232-B6073B69BD3D";
    var DivName = "PrefWidget";
    var SelectType = "00";
    var LanaguageCode = getLang();

    window.onload = function () {
      GetWidget(
        WidgetId,
        LicenseKey,
        AccessKey,
        "PrefWidget",
        "00",
        LanaguageCode
      );
      var CookieConsentID = checkCookie("CookieConsentID");
    };
  }

  function loadScriptWithFallback() {
    const rootDomain = getRootDomain(window.location.href);
    let scriptUrl = rootDomain
      ? `https://wscript-cdn-use.${rootDomain}/widget.js`
      : "https://wscript-cdn-use.cassiecloud.com/widget.js";
    window.cassieResourceRootDomain = rootDomain;

    loadScript(
      scriptUrl,
      () => {
        initCassieWidget();
      },
      () => {
        window.cassieResourceRootDomain = null;
        loadScript("https://wscript-cdn-use.cassiecloud.com/widget.js", () => {
          initCassieWidget();
        });
      }
    );
  }

  loadScriptWithFallback();
});

window.addEventListener("load", function () {
  addAttributeToClass(
    "onClick",
    "SubmitWidget();",
    "frcp-cf-btn frcp-cf-btn--submit"
  );
  // this part added by Amir to activate Read More button
  setTimeout(() => {
        const registrationReadMoreContext = document.getElementById('registration-read-more-context');
        const registrationReadMoreBtns = document.getElementById('registration-read-more-btn');
		registrationReadMoreBtns.textContent = 'Read More';

        registrationReadMoreBtns.addEventListener('click', (event) => {
            event.preventDefault();
            registrationReadMoreContext.style.maxHeight = registrationReadMoreContext.style.maxHeight === '60px' ? '100%' : '60px';
            registrationReadMoreBtns.textContent = registrationReadMoreBtns.textContent === 'Read More' ? 'Read Less' : 'Read More';
        });
  }, 1000);
});

function addAttributeToClass(attributeName, attributeValue, className) {
  // Get all elements with the class
  const elements = document.getElementsByClassName(className);

  // Loop through each element
  for (const element of elements) {
    // Add the attribute to the element
    element.setAttribute(attributeName, attributeValue);
  }
}

// Save the preference widget contents to Cassie after Shopify has validated the form on server side
function SubmitWidget() {
  var WidgetId = 1;
  //alert (document.getElementById('contactid').value);
  SaveWidget(WidgetId, "D0A47C10-5DA3-412D-9232-B6073B69BD3D", "PrefWidget");
}

/*
	var form = document.forms[0]; //Change this to correspond to your form. The form's submit button cannot be called "submit"
	form.addEventListener("submit", function(e) {
		e.preventDefault(); //Intercept form submit and run SaveWidget()
		SaveWidget('2', '7818DA97-EDAF-4F97-9A08-7E365E12EAE3', 'PrefWidget');
	});
*/

function SaveWidget(FormID, LicenseID, DivID) {
  var PostURL = "https://wscript-use.cassiecloud.com/widgetsapi/submit";
  /*
  if (window.cassieResourceRootDomain != null) {
    PostURL = PostURL.replace(
      "cassiecloud.com",
      window.cassieResourceRootDomain
    );
  }
*/
  var ObjectArray = []; // Define an empty Object Array
  var RecordObject = {}; // Define an empty Record Object for holding data
  /*
   * Forename, Surname and Email1 are required fields within the RecordObject,
   * the remaining fields are optional and need not be defined at all unless
   * you plan to use them.
   */
  //*** Scrape form fields for matching ***//
  RecordObject.DivID = DivID; // This is the name of the container that holds the Cassie widget.
  RecordObject.LanguageCode = cassieWidgetLanguageCode;

  let NoCassiesubmit = 0;
  console.log(NoCassiesubmit);
  const inputElements = document.querySelectorAll(".frcp-cf__control");
  RecordObject.Forename = "";
  RecordObject.Surname = "";
  RecordObject.Email1 = "";
  for (const inputElement of inputElements) {
    const inputTitle = inputElement.title;
    if (inputElement.tagName === "INPUT" && inputTitle !== "") {
      const inputValue = inputElement.value;
      switch (inputTitle) {
        case "First name":
          RecordObject.Forename = inputValue;
          NoCassiesubmit++;
          break;
        case "Last name":
          RecordObject.Surname = inputValue;
          NoCassiesubmit++;
          break;
        case "Email":
          RecordObject.Email1 = inputValue;
          RecordObject.Email1 = encodeURIComponent(RecordObject.Email1);
          NoCassiesubmit++;
          break;
      }
    }
  }
  if (NoCassiesubmit != 0) {
    if (document.getElementsByName("contactid")[0] != undefined) {
      if (document.getElementsByName("contactid")[0].value !== "") {
        RecordObject.URN2 = document.getElementsByName("contactid")[0].value;
      } else {
        RecordObject.URN2 = "";
      }
    }

    //If we have a cookie preference already saved for this record, then add it to the record object for processing
    var deviceGUID = document.cookie.replace(
      /(?:(?:^|.*;\s*)SyrenisGuid_.+?\s*\=\s*([^;]*).*$)|^.*$/,
      "$1"
    );
    if (deviceGUID != "") {
      RecordObject.DeviceGUID = deviceGUID;
    }
    //*** Process preferences ***//
    // Add preferences to RecordObject, and RecordObject to ObjectArray
    RecordObject.Preferences = GetPreferencesArray();
    ObjectArray.push(RecordObject);
    RecordObject.FormID = FormID;
    RecordObject.LicenseID = LicenseID;
    //Log values
    //console.log("PostURL=" + PostURL);
    //console.log("RecordObject = " + JSON.stringify(RecordObject));
    // Post the data to the Cassie web service
    var xmlhttp = new XMLHttpRequest();
    xmlhttp.open("POST", PostURL, true);
    xmlhttp.setRequestHeader("Content-type", "application/json");
    xmlhttp.onreadystatechange = function () {
      if (xmlhttp.readyState === 4) {
        if (xmlhttp.status === 200) {
          //Submit form as usual
          console.log("Submitting to Cassie");
          //window.Shopify.recaptchaV3.addToken(this, "create_customer");
          //form.submit();
        }
      }
    };
    var JSONRecordObject = JSON.stringify(RecordObject);
    console.log(JSONRecordObject);
    xmlhttp.send(JSONRecordObject);
    console.log(NoCassiesubmit);
  }
}
